import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubPipelineDetails from './Subcomponents/PipelineDetails';
import withRouter from './Functions/WithRouter';

class EmpPipelineDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }

        this.loadWorkspace = this.loadWorkspace.bind(this)
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const { emp, id } = this.props.params

      let selectedBenchmark = null
      if (this.props.location && this.props.location.state) {
        selectedBenchmark = this.props.location.state.selectedBenchmark
      }

      //obtain email id from localStorage
      let email = localStorage.getItem('email');
      let username = localStorage.getItem('username');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      let activeOrg = localStorage.getItem('activeOrg');
      const orgLogo = localStorage.getItem('orgLogo');

      let orgMode = true
      if (!activeOrg || activeOrg === '' || activeOrg === 'guidedcompass') {
        orgMode = false
      }

      this.setState({ emailId: email, username, cuFirstName, cuLastName, emp,
        activeOrg, orgMode, orgLogo, selectedBenchmark, pipelineId: id
      })
    }

    loadWorkspace(org) {
      console.log('loadWorkspace called', org)
      this.setState({ org })
    }

    render() {

      return (
          <div>
            <AppNavigation fromEmployer={true} emp={this.state.emp} org={this.state.activeOrg} orgMode={this.state.orgMode} history={this.props.navigate} loadWorkspace={this.loadWorkspace}/>
            <SubPipelineDetails source="Employer" activeOrg={this.state.activeOrg} accountCode={this.state.emp} selectedTemplate={this.state.selectedBenchmark} pipelineId={this.state.pipelineId} history={this.props.navigate}/>

            {(this.state.activeOrg) && (
              <div>
                {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
              </div>
            )}
          </div>
      )
    }
}

export default withRouter(EmpPipelineDetails)
